import { Outlet, createRootRoute } from '@tanstack/react-router';
import { Header } from '~/components/header';

export const Route = createRootRoute({
  component: () => (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  ),
});
